<template>
    <div class="navigation-entry" :class="[bemFacets, rootClasses]">
        <a class="u-reset navigation-entry--label"
                :class="labelActiveClass"
                :href="path"
        >
            {{ label }}
        </a>
        <navigation-entry class="navigation-entry--child"
                v-for="(item, idx) in items"
                :key="idx"
                :is-child="true"
                :facets="facets"
                v-bind="item"/>
    </div>
</template>

<script>

    import { mapActions } from 'vuex';
    import bemMixin from 'framework/mixins/bem';

    export default {
        name: 'NavigationEntry',
        mixins: [bemMixin('navigation-entry')],
        props: {
            isChild: {
                type: Boolean,
                default: false,
            },

            label: {
                type: String,
                required: true,
            },

            path: {
                type: String,
                required: true,
            },

            is_active: {
                type: Boolean,
                default: false,
            },

            has_active_children: {
                type: Boolean,
                default: false,
            },

            description: {
                type: String,
                default: null,
            },

            preview_link_label: {
                type: String,
                default: null,
            },

            image: {
                type: Object,
                default: null,
            },

            /** @type {INavigationEntry[]} */
            items: {
                type: Array,
                default: null,
            },
        },

        computed: {
            labelActiveClass() {
                if (this.has_active_children && (!this.items || this.items.length <= 0)) {
                    return this.bemAdd('active', 'label');
                }

                return this.bemAdd(this.is_active ? 'active' : '', 'label');
            },

            rootClasses() {
                return [
                    this.bemAdd(this.isChild ? 'child' : 'root'),
                ];
            },
        },

        methods: {
            ...mapActions('navigation', ['setPreviewContent']),
        },
    };
</script>
